import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalContentText,
    ModalTitle,
} from '@deere/fuel-react';
import { PropTypes } from 'prop-types';
import { usePrompt } from '../../hooks/usePrompt';
import { usePromptNavigation } from '../../hooks/usePromptNavigation';

export const PromptInvalidState = (props) => {
    usePrompt(props.isFormChanged);
    const [showPrompt, leavePage, stayOnPage] = usePromptNavigation(
        props.isFormChanged
    );

    return (
        <Modal
            open={showPrompt}
            onClose={stayOnPage}
            aria-labelledby="alert-Modal-title"
            aria-describedby="alert-Modal-description"
        >
            <ModalTitle id="alert-Modal-title">
                Do You Want to Discard Changes?
            </ModalTitle>
            <ModalContent>
                <ModalContentText id="alert-Modal-description">
                    {props.message !== null && <span>{props.message}</span>}
                    {props.message == null && (
                        <span>
                            The changes are in an invalid state; do you want to
                            discard or go back to correct?
                        </span>
                    )}
                </ModalContentText>
            </ModalContent>
            <ModalActions>
                <Button onClick={leavePage} variant="secondary">
                    Do Not Save Changes
                </Button>
                <Button onClick={stayOnPage} variant="primary">
                    Stay On Page
                </Button>
            </ModalActions>
        </Modal>
    );
};
PromptInvalidState.propTypes = {
    isFormChanged: PropTypes.bool.isRequired,
    areAllFieldsValid: PropTypes.func.isRequired,
    message: PropTypes.string,
};
